// Third payty and libraries
import React, { useEffect, useMemo, useState } from "react";
import { Form, Button, Row, Col, Spinner } from "react-bootstrap";
import Select from "react-select";
import { Formik, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import { useLazyQuery, useMutation } from "@apollo/client";
// import { toast } from "react-toastify";

// constant
import { HAL_KEY, LOGISTICS_DATAS, MIXAY_KEY } from "../../../constants";
import { ADD_SHOP_ADDRESS_VALIDATE, CREATE_SHOP_ADDRESS, PUT_SHOP_ADDRESS } from "../../../graphql/shop/shopAddress/mutation";
import {
  GET_HAL_BRANCHS,
  GET_MIXAY_DROP_SHIPS_V2,
  GET_MIXAY_DROPSHIPS,
  GET_MIXAY_PROVINCES,
  GET_MIXAY_PROVINCES_V2,
} from "../../../graphql/shop/shopAddress/query";
import _ from "lodash";
import { useToasts } from "react-toast-notifications";
import LoadingUpdates from "../../../components/LoadingUpdates";

// Validation schema using Yup
const validationSchema = Yup.object().shape({
  shopName: Yup.string().required("ຕ້ອງປ້ອນຊື່ຜູ້ຝາກ ຫຼື ຊື່ຮ້ານກ່ອນ!"),
  shopPhone: Yup.string()
    .required("ຕ້ອງປ້ອນເບີໂທລະສັບກ່ອນ!")
    .matches(/^[0-9]+$/, "ເບີໂທ ຕ້ອງເປັນຕົວເລກ 0 - 9 ເທົ່ານັ້ນ"),
  // codNumber: Yup.string().required("ປ້ອນລະຫັດ COD ກ່ອນ!"),
});

export default function FormDefaultAddress({
  editData,
  setEditData,
  onCloseModalAdd,
  fetchShopAddressDefault,
  isLogistics
}) {
  const { addToast } = useToasts();
  const localShop = localStorage.getItem("SHOP_DATA");
  let shopData = JSON.parse(localShop);

  // state
  const [logistics, setLogistics] = useState([]);
  const [logicticsAddress, setLogicticsAddress] = useState({
    provinces: [],
    districts: [],
    villages: [],
    branchDatas: [],
  });
  const [provinceOption, setProvinceOption] = useState([]);
  const [districtOption, setDistrictOption] = useState([]);
  const [villageOption, setVillageOption] = useState([]);
  const [branchOption, setBranchOption] = useState([]);
  const [formState, setFormState] = useState({
    _province: "",
    _district: "",
    _branchName: "",
    branchOption: {},
  });
  const [isValidate, setIsValidate] = useState({
    alertLogictics: editData?.deliveryName ? false : true,
  });
  const [textAlert, setTextAlert] = useState();
  const [activeLogictics, setActiveLogictics] = useState();
  const [mixayDropShipByProvince, setMixayDropShipByProvince] = useState([]);
  const [isCorrectBranchOption, setIsCorrectBranchOption] = useState({ pv: false, dt: false, br: false });
  const handleDefaultLogistic = (value) => {
    setActiveLogictics(value);
    switch (value) {
      case HAL_KEY:
        return {
            value: LOGISTICS_DATAS?.hal?.keyDefault,
            label: (
              <div>
                <img
                  style={{
                    width: 20,
                    height: 20,
                    marginRight: 10,
                    borderRadius: "40em",
                  }}
                  src={LOGISTICS_DATAS?.hal?.image}
                  alt={LOGISTICS_DATAS?.hal?.keyDefault}
                />
                {LOGISTICS_DATAS?.hal?.name}
              </div>
            )
        }
      case MIXAY_KEY:
        return {
          value: LOGISTICS_DATAS?.mixay?.keyDefault,
          label: (
            <div>
              <img
                style={{ width: 20, height: 20, marginRight: 10, borderRadius: 5 }}
                src={LOGISTICS_DATAS?.mixay?.image}
                alt={LOGISTICS_DATAS?.mixay?.keyDefault}
              />
              {LOGISTICS_DATAS?.mixay?.name}
            </div>
          )
        }
      default:
        return null;
    }
  };


  // apollo client query
  const [
    getHalBranchDatas,
    { data: halBranchDatas, loading: loadingBanchHal },
  ] = useLazyQuery(GET_HAL_BRANCHS, { fetchPolicy: "network-only" });
  const [
    getMixayProvincesV2,
    { data: mixayProvinces, loading: loadingProvinceMixayV2 },
  ] = useLazyQuery(GET_MIXAY_PROVINCES_V2, { fetchPolicy: "network-only" });
  const [
    getMixayDropShipsV2,
    // { data: mixayDropShips, loading: loadingDropshipMixay },
  ] = useLazyQuery(GET_MIXAY_DROP_SHIPS_V2, { fetchPolicy: "network-only" });

  // apolloo client mutaion
  // const [createShopAddressDefault, { loading: loadingAddShopAddresss }] =
  //   useMutation(CREATE_SHOP_ADDRESS);

  const [addShopAddressValidate, { loading: loadingAddShopAddressValidate }] =
    useMutation(ADD_SHOP_ADDRESS_VALIDATE);
  const [putShopAddress, { loading: loadingPutShopAddress }] = useMutation(PUT_SHOP_ADDRESS);

  // useMemo
  const defaultDelivery = useMemo(() => {
    const name = editData?.deliveryName;
    if (name) {
      if (name === HAL_KEY) {
        getHalBranchDatas();
      } else if (name === MIXAY_KEY) {
        getMixayProvincesV2();
      }
      return handleDefaultLogistic(name);
    } else return null;
  }, [editData?.deliveryName]);

  // useEffect
  useEffect(() => {
    try {
      if (!_.isEmpty(halBranchDatas)) {
        // Set logistics address from the response data
        setLogicticsAddress({
          provinces: halBranchDatas?.getHalBranchList?.provinces,
          districts: halBranchDatas?.getHalBranchList?.districts,
          villages: halBranchDatas?.getHalBranchList?.villages,
          branchDatas: JSON.parse(
            halBranchDatas?.getHalBranchList?.branchDatas
          ),
        });

        // Map province options for react-select
        const provinceOptions = halBranchDatas?.getHalBranchList?.provinces.map(
          (province) => ({
            value: province.id,
            label: province.name,
          })
        );
        setProvinceOption(provinceOptions);

        // Map village options for react-select
        const villageOptions = halBranchDatas?.getHalBranchList?.villages.map(
          (village) => ({
            value: village.id,
            label: village.name,
          })
        );
        setVillageOption(villageOptions);
      }
      if (!_.isEmpty(mixayProvinces)) {
        let mixayProvinceOptions =
          mixayProvinces?.getMixayProvincesV2?.provinces.map((province) => ({
            value: province.id,
            label: province.name,
          }));
        setProvinceOption(mixayProvinceOptions);
      }
    } catch (error) {
      console.error(error);
    }
  }, [halBranchDatas, mixayProvinces]);

  useEffect(() => {
    if(isLogistics){
      handleLogistics(isLogistics);
    }
  }, [isLogistics]);

  // Handle Logistics
  const handleLogistics = (value) => {
    if (value?.halIsOpen) {
      setLogistics((prev) => ([...prev, {
        value: LOGISTICS_DATAS?.hal?.keyDefault,
        label: (
          <div>
            <img
              style={{
                width: 20,
                height: 20,
                marginRight: 10,
                borderRadius: "40em",
              }}
              src={LOGISTICS_DATAS?.hal?.image}
              alt={LOGISTICS_DATAS?.hal?.keyDefault}
            />
            {LOGISTICS_DATAS?.hal?.name}
          </div>
        ),
      },]));
    }
    if(value?.mxIsOpen){
      setLogistics((prev) => ([...prev,{
          value: LOGISTICS_DATAS?.mixay?.keyDefault,
          label: (
            <div>
              <img
                style={{ width: 20, height: 20, marginRight: 10, borderRadius: 5 }}
                src={LOGISTICS_DATAS?.mixay?.image}
                alt={LOGISTICS_DATAS?.mixay?.keyDefault}
              />
              {LOGISTICS_DATAS?.mixay?.name}
            </div>
          ),
        }
      ]));
    }
    if(value?.ansIsOpen){
      setLogistics((prev) => ([...prev, {
          value: LOGISTICS_DATAS?.anusith?.keyDefault,
          label: (
            <div style={{ opacity: 0.5 }}>
              <img
                style={{
                  width: 20,
                  height: 20,
                  marginRight: 10,
                  borderRadius: "40em",
                }}
                src={LOGISTICS_DATAS?.anusith?.image}
                alt={LOGISTICS_DATAS?.anusith?.keyDefault}
              />
              {LOGISTICS_DATAS?.anusith?.name}
            </div>
          ),
        },
      ]));
    }
  };

  // create shop address default
  const handleProcessShopAddress = async (values) => {
    if(!isCorrectBranchOption?.pv || !isCorrectBranchOption?.dt || !isCorrectBranchOption?.br) {
      handleAlert("ຂໍອະໄພ ແຂວງ, ເມືອງ, ສາຂາ ບໍ່ຖືກ ກະລຸນາເລືອກໃຫມ່", "error");
      return;
    }
    try {
      if (loadingAddShopAddressValidate) return;
      let _branchDatas = JSON.parse(formState?._branchName);
      const _branchOption = formState?.branchOption;
      let _data = {
        shop: shopData?.id,
        fullName: values?.shopName ?? shopData?.name,
        shopName: shopData?.name,
        shopTel: values?.shopPhone ?? shopData?.phone,
        codNumber: values?.codNumber,
        deliveryName: values?.logistics?.value,
        province: formState?._province,
        district: formState?._district,
        village: _branchDatas?.label,
        branch: _branchDatas?.label,
        sender_branch_id:
          activeLogictics === MIXAY_KEY
            ? Number(_branchDatas?.value)
            : _branchDatas?.value,
        isOpen: true
      };

      if (activeLogictics === MIXAY_KEY) {
        delete _data.sender_branch_id;
        _data = {
          ..._data,
          address: _branchOption?.address_detail ?
            _branchOption?.address_detail 
            :_branchOption?.code + "-" + _data?.village + "-" + _data?.district + "-" + _data?.province,
          postcode: _branchOption?.postcode,
          village: _branchOption?.village?.vill_name,
          dropship_end: _branchOption?.id,
          branch: _branchOption?.name,
          branchCode: _branchOption?.code
        }
      } else {
        if (_data?.sender_branch_id < 0) {
          handleAlert("ບໍ່ສາສມາດສ້າງຂົນສົ່ງຮຸ່ງອາລຸນ, ກະລຸນາລອງໃຫມ່ພາຍຫລັງ", "error");
          return;
        }
      }
      // handle edit or update
      if(_.isEmpty(editData)) {
        await addShopAddressValidate({
          variables: {
            data: _data,
          }
        }).then((response => {
          fetchShopAddressDefault(shopData?.id);
          setIsCorrectBranchOption({ pv: false, dt: false, br: false });
          onCloseModalAdd();
        }))
        handleAlert("ສ້າງທີ່ຢູ່ຕົ້ນທາງສຳເລັດ", "success");
      } else {
        await putShopAddress({
          variables: {
            where: { id: editData?.id },
            data: _data,
          }
        })
        setEditData({});
        fetchShopAddressDefault(shopData?.id);
        setIsCorrectBranchOption({ pv: false, dt: false, br: false });
        onCloseModalAdd();
        handleAlert("ແກ້ໄຂທີ່ຢູ່ຕົ້ນທາງສຳເລັດ", "success");
      }
    } catch (error) {
      console.log({ error });
      //DUPLICATE_ADDRESS
      if(error?.message === "DUPLICATE_ADDRESS") {
        setIsCorrectBranchOption({ pv: false, dt: false, br: false });
        onCloseModalAdd();
        handleAlert("ທ່ານມີທີ່ຢູ່ຕົ້ນທາງນີ້ແລ້ວ", "warning");
        return;
      }
      handleAlert("ສ້າງທີ່ຢູ່ຕົ້ນທາງບໍ່ສຳເລັດ!", "error");
    }
  };

  const handleAlert = (message, appearance) => {
    addToast(message, {
      appearance: appearance,
      autoDismiss: true,
    });
  }

  // get mixay dropships
  const handleMixayDropShip = async (id) => {
    try {
      const response = await getMixayDropShipsV2({
        variables: {
          where: {
            // provinceName: _name,
            provinceId: id,
          },
        },
      });
      // .then((response) => {
        if (!_.isEmpty(response?.data)) {
          const _resDropShip = JSON.parse(
            response?.data?.getMixayDropShipsV2?.branchDatas
          );

          // Create a Set to store unique district names
          const uniqueDistricts = new Set();

          // Filter the districts and map them to the options format, ensuring each district name is unique
          const provinceOptions = _resDropShip
            .filter((district) => {
              const isUnique = !uniqueDistricts.has(district?.dristric?.dr_id);
              uniqueDistricts.add(district?.dristric?.dr_id); // Add the district name to the set
              return isUnique;
            })
            .map((district) => {
              return {
              value: district?.dristric?.dr_id, //district.id,
              label: district?.dristric?.dr_name //district.dristric,
            }});

          // Set the district options
          setDistrictOption(provinceOptions);
          setMixayDropShipByProvince(_resDropShip);
        }
    } catch (error) {
      console.log("Error in handleMixayDropShip:", error);
      handleAlert("ພົບຂໍ້ຜີດຜາດ ບໍ່ພົບຂໍມູນສາຂາ", "error");
      // toast.error("ພົບຂໍ້ຜີດຜາດ ບໍ່ພົບຂໍມູນສາຂາ");
      return;
    }
  };

  // select province to filter district all
  const onChangeProvince = (value, setFieldValue) => {
    setFieldValue("province", value);
    setFormState((prevState) => ({
      ...prevState,
      _province: value?.label,
    }));
    // console.log("activeLogictics", activeLogictics);

    switch (activeLogictics) {
      case MIXAY_KEY:
        // Handle MIXAY_KEY logic
        handleMixayDropShip(value?.value);
        break;

      case HAL_KEY:
        // Handle HAL_KEY logic
        const _districtOptions = logicticsAddress?.districts.filter(
          (data) => data?.province_id === value?.value
        );
        const provinceOptions = _districtOptions.map((district) => ({
          value: district.id,
          label: district.name,
        }));

        setDistrictOption(provinceOptions);
        break;

      default:
        // Handle any other keys or default logic if needed
        break;
    }
  };

  // select district to filter branches
  const onChangeDistrict = async (value, setFieldValue) => {
    setFieldValue("district", value);
    if (!logicticsAddress?.branchDatas || !value) return;

    setFormState((prevState) => ({
      ...prevState,
      _district: value?.label,
    }));
    setIsCorrectBranchOption((prev) => ({ ...prev, dt: true, br: false }));

    switch (activeLogictics) {
      case MIXAY_KEY:
        // Handle MIXAY_KEY logic
        handleMixayDistrict(value?.value);
        break;

      case HAL_KEY:
        // Handle HAL_KEY logic
        const _villageOptions = logicticsAddress.branchDatas.filter((data) => {
          return Number(data?.district_id) === Number(value?.value);
        });

        const _branchOption = _villageOptions.map((branch) => ({
          value: branch.id,
          label: branch.name,
        }));

        setVillageOption(_branchOption);
        break;

      default:
        // Handle any other keys or default logic if needed
        break;
    }
  };

  // select branch data
  const onChangeBranch = (value, setFieldValue) => {
    setFieldValue("village", value);
    setIsCorrectBranchOption((prev)=> ({...prev, br: true}))
    if (activeLogictics === MIXAY_KEY) {
      const newBranch = branchOption.filter((b) => { return b.code === value?.value });
      setFormState((prevState) => ({
        ...prevState,
        _branchName: JSON.stringify(value),
        branchOption: newBranch[0]
      }));
    } else {
      setFormState((prevState) => ({
        ...prevState,
        _branchName: JSON.stringify(value),
      }));
    }
  };

  // filter branch in province for mixay
  const handleMixayDistrict = (_keyFilter) => {
    const _dropShipOptions = mixayDropShipByProvince.filter((data) => {
      return data?.dristric?.dr_id === _keyFilter;
    });

    if (!_.isEmpty(_dropShipOptions)) {
      const _branchOption = _dropShipOptions.reduce((options, branch) => {
        options.push({
          value: branch?.code,
          label: branch?.name,
          // label: branch?.village?.vill_name,
        });
        return options;
      }, []);
      setVillageOption(_branchOption);
      setBranchOption(_dropShipOptions);
    }
  };

  // handle change get logictics
  const handleChange = (selectedOption, setFieldValue) => {
    setFieldValue("logistics", selectedOption);
    setIsValidate({
      alertLogictics: false,
    });
    setTextAlert();
    setActiveLogictics(selectedOption?.value); // get active when select the logictics

    if (selectedOption?.value === HAL_KEY) {
      getHalBranchDatas();
    } else if (selectedOption?.value === MIXAY_KEY) {
      getMixayProvincesV2();
    } else {
      setProvinceOption([]);
      setDistrictOption([]);
      setVillageOption([]);
    }
  };
  if(loadingAddShopAddressValidate) {
    return (
      <LoadingUpdates title="ກຳລັງໂຫລດ..." openLoading={loadingAddShopAddressValidate} />
    )
  }
  return (
    <Formik
    initialValues={{
        logistics: defaultDelivery ?? null,
        province: {value: 0, label: editData?.province ?? null},
        district: {value: 0, label: editData?.district ?? null},
        village: {value: 0, label: editData?.branch ?? editData?.village ?? null},
        shopName: editData?.fullName ?? shopData?.name ?? "",
        shopPhone: editData?.shopTel ?? shopData?.phone ?? "",
        codNumber: editData?.codNumber ??  ""
      }}
      validationSchema={validationSchema}
      onSubmit={(values) => {
        if (isValidate?.alertLogictics) {
          setTextAlert("ຕ້ອງເລືອກຂົນສົ່ງກ່ອນ");
          return;
        }
        handleProcessShopAddress(values);
      }}
    >
      {({ handleSubmit, setFieldValue, values }) => (
        <Form noValidate onSubmit={handleSubmit}>
          <Row>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>ຂົນສົ່ງ</Form.Label>
                <Select
                  isDisabled={defaultDelivery ? true : false}
                  options={logistics}
                  onChange={(selectedOption) => {
                    setFieldValue("province", null);
                    handleChange(selectedOption, setFieldValue);
                    setIsCorrectBranchOption({ pv: false, dt: false, br: false });
                  }}
                  placeholder="-ເລືອກ-"
                  value={values.logistics}
                />
              </Form.Group>
            </Col>

            {/* Province Selection */}
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>
                  ແຂວງ{" "}
                  {(loadingBanchHal || loadingProvinceMixayV2) && (
                    <Spinner size="sm" animation="grow" />
                  )}
                </Form.Label>
                <Select
                  options={provinceOption}
                  onChange={(value) => {
                    // setFieldValue("province", selectedProvince);
                    onChangeProvince(value, setFieldValue);
                    setIsCorrectBranchOption((prev) => ({ ...prev, pv: true, dt: false, br: false }));
                  }}
                  placeholder="-ເລືອກ-"
                  value={values.province}
                />
                {(!_.isEmpty(textAlert)) ? (
                  <small className="text-danger">{textAlert}</small>
                ) : (
                  ""
                )}
                {(!isCorrectBranchOption?.pv) ? (
                  <small className="text-danger">ກະລຸນາເລືອກແຂວງໃຫມ່</small>
                ) : null}
              </Form.Group>
            </Col>

            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>ເມືອງ</Form.Label>
                <Select
                  isDisabled={districtOption.length === 0}
                  options={districtOption}
                  onChange={(value) => (onChangeDistrict(value, setFieldValue))}
                  placeholder="-ເລືອກ-"
                  value={values.district}
                />
                {(!isCorrectBranchOption?.dt) ? (
                  <small className="text-danger">ກະລຸນາເລືອກເມືອງໃຫມ່</small>
                ) : null}
              </Form.Group>
            </Col>
            <Col md={6}>
              <Form.Group className="mb-3">
                <Form.Label>ສາຂາ</Form.Label>
                <Select
                  isDisabled={villageOption.length === 0}
                  options={villageOption}
                  onChange={(value) => {onChangeBranch(value, setFieldValue)}}
                  placeholder="-ເລືອກ-"
                  value={values.village}
                />
                {(!isCorrectBranchOption?.br) ? (
                  <small className="text-danger">ກະລຸນາເລືອກສາຂາໃຫມ່</small>
                ) : null}
              </Form.Group>
            </Col>
          </Row>

          <Form.Group className="mb-3">
            <Form.Label>ຊື່ຜູ້ຝາກ ຫຼື ຊື່ຮ້ານ</Form.Label>
            <Field
              name="shopName"
              className="form-control"
              type="text"
              placeholder="ປ້ອນຊື່ຜູ້ຝາກ"
            />
            <ErrorMessage
              name="shopName"
              component="small"
              className="text-danger"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>ເບີໂທຜູ້ຝາກ</Form.Label>
            <Field
              maxLength={8} pattern="[0-9]{8}"
              name="shopPhone"
              className="form-control"
              type="text"
              placeholder="ປ້ອນເບີໂທຜູ້ຝາກ"
            />
            <ErrorMessage
              name="shopPhone"
              component="small"
              className="text-danger"
            />
          </Form.Group>

          <Form.Group className="mb-3">
            <Form.Label>ລະຫັດ COD (ຖ້າມີ)</Form.Label>
            <Field
              maxLength={8} pattern="[0-9]{8}"
              name="codNumber"
              className="form-control"
              type="text"
              placeholder="ປ້ອນລະຫັດ cod"
            />
            <ErrorMessage
              name="codNumber"
              component="small"
              className="text-danger"
            />
          </Form.Group>

          <div className="d-flex w-100 justify-content-end gap-2">
            <Button type="button" variant="light" onClick={() => {onCloseModalAdd(); setEditData({});}} disabled={loadingAddShopAddressValidate}>
              ຍົກເລີກ
            </Button>
            <Button
              type="submit"
              variant="info"
              disabled={(loadingAddShopAddressValidate && loadingPutShopAddress) ? true : false}
            >
              {(loadingAddShopAddressValidate && loadingPutShopAddress) ? (
                <>
                  <Spinner size="sm" /> ກຳລັງສ້າງ...
                </>
              ) : (
                "ຢືນຢັນ"
              )}
            </Button>
          </div>
        </Form>
      )}
    </Formik>
  );
}

// const logisticsOptions = [
//   {
//     value: LOGISTICS_DATAS?.mixay?.keyDefault,
//     label: (
//       <div
//       >
//         <img
//           style={{ width: 20, height: 20, marginRight: 10, borderRadius: 5 }}
//           src={LOGISTICS_DATAS?.mixay?.image}
//           alt={LOGISTICS_DATAS?.mixay?.keyDefault}
//         />
//         {LOGISTICS_DATAS?.mixay?.name}
//       </div>
//     ),
//   },

//   {
//     value: LOGISTICS_DATAS?.hal?.keyDefault,
//     label: (
//       <div>
//         <img
//           style={{
//             width: 20,
//             height: 20,
//             marginRight: 10,
//             borderRadius: "40em",
//           }}
//           src={LOGISTICS_DATAS?.hal?.image}
//           alt={LOGISTICS_DATAS?.hal?.keyDefault}
//         />
//         {LOGISTICS_DATAS?.hal?.name}
//       </div>
//     ),
//   },

//   // {
//   //   value: LOGISTICS_DATAS?.anusith?.keyDefault,
//   //   label: (
//   //     <div style={{ opacity: 0.5 }}>
//   //       <img
//   //         style={{
//   //           width: 20,
//   //           height: 20,
//   //           marginRight: 10,
//   //           borderRadius: "40em",
//   //         }}
//   //         src={LOGISTICS_DATAS?.anusith?.image}
//   //         alt={LOGISTICS_DATAS?.anusith?.keyDefault}
//   //       />
//   //       {LOGISTICS_DATAS?.anusith?.name}
//   //     </div>
//   //   ),
//   // },
// ];
